import React from "react";
import "./previewloading.css";

const PreviewLoading = () => {
  return (
    <div style={{ position: "absolute", top: "40%", height: "100%" }}>
      <div className="bulder-wrapper">
        <div className="builder-sk-folding-cube">
          <div className="builder-sk-cube1 builder-sk-cube" />
          <div className="builder-sk-cube2 builder-sk-cube" />
          <div className="builder-sk-cube4 builder-sk-cube" />
          <div className="builder-sk-cube3 builder-sk-cube" />
        </div>
        <div style={{ textAlign: "center" }}>
          Please wait...
          <br />
          Your website will be ready in few minutes.
        </div>
      </div>
    </div>
  );
};

export default PreviewLoading;
